/**
 * @file 应用运行环境与设备相关 utils
 */
var _a, _b;
/**
 * 检查当前设备是否是触摸屏设备.
 * 供某些在触摸屏上需要有特殊交互的场景使用 (如双值缩放图片).
 * 由于最新 iPadOS Safari 与 MacOS Safari 的 UA 已无区别,
 * 无法再通过 UA 来识别 iPad, 改为检查 window.navigator.maxTouchPoints.
 *
 * @category Environment
 */
export const isTouchableDevice = typeof window !== 'undefined' && ((_a = window.navigator) === null || _a === void 0 ? void 0 : _a.maxTouchPoints) > 0;
/**
 * 当前是否在 react native 环境中.
 * 注意, 如果在 react native 的 webview 中, 该值为 false.
 *
 * @category Environment
 */
export const isReactNative = typeof window !== 'undefined' && ((_b = window.navigator) === null || _b === void 0 ? void 0 : _b.product) === 'ReactNative';
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZW52aXJvbm1lbnQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvZnVuY3Rpb25zL2Vudmlyb25tZW50LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBOztHQUVHOztBQUVIOzs7Ozs7O0dBT0c7QUFDSCxNQUFNLENBQUMsTUFBTSxpQkFBaUIsR0FDNUIsT0FBTyxNQUFNLEtBQUssV0FBVyxJQUFJLENBQUEsTUFBQSxNQUFNLENBQUMsU0FBUywwQ0FBRSxjQUFjLElBQUcsQ0FBQyxDQUFBO0FBRXZFOzs7OztHQUtHO0FBQ0gsTUFBTSxDQUFDLE1BQU0sYUFBYSxHQUN4QixPQUFPLE1BQU0sS0FBSyxXQUFXLElBQUksQ0FBQSxNQUFBLE1BQU0sQ0FBQyxTQUFTLDBDQUFFLE9BQU8sTUFBSyxhQUFhLENBQUEifQ==